import * as React from 'react';
import { Loader } from '../../atoms/forms/loader';
import { animated, useSpring } from 'react-spring';
import './loadingIndicator.module.scss';

export const LoadingIndicator = ({ show }) => {
    const styleProps = useSpring({ opacity: show ? 1 : 0, bottom: show ? '50px' : '0px' });
    return (
        <animated.div styleName="floating-loader" style={styleProps}>
            <Loader styleName="loader-svg" />Loading...
        </animated.div>
    );
};
